<template>
  <div>
    <div style="margin-bottom:15px;">
      <span class="common-title">其他资产</span>
      <span
        class="text-color-blue pointer right-oper"
        @click="showMore = !showMore"
      >
        {{ showMore ? "收起" : "展开" }}
        <a-icon :type="showMore ? 'up' : 'down'" style="font-size:12px" />
      </span>
    </div>
    <table class="table-common">
      <thead>
        <tr>
          <th>文件名称</th>
          <th>上传人</th>
          <th>上传日期</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody v-if="showMore">
        <tr v-for="(item, index) in pageData" :key="index">
          <td>{{ item.fileNm}}</td>
          <td>{{ item.createUser }}</td>
          <td>{{ item.createTime | dateFormat("YYYY-mm-dd HH:MM:SS") }}</td>
          <td>
            <a @click="downloadFile(item)">下载</a>
            <a v-if="item.file&&!(item.file.fileExpdNm.indexOf('ZIP')||item.file.fileExpdNm.indexOf('zip'))" @click="lookFile(item)">查看</a>
            <a v-if="!(item.fileExpdNm.includes('ZIP')||item.fileExpdNm.includes('zip'))" @click="lookFile(item)">查看</a>
          </td>
        </tr>
        <tr v-if="pageData.length == 0">
          <td colspan="8" style="text-align: center;">暂无数据</td>
        </tr>
      </tbody>
      <tbody v-if="!showMore">
        <tr>
          <td colspan="8" style="text-align: center;color:#999;font-size:18px;">
            ···
          </td>
        </tr>
      </tbody>
    </table>
     <!-- 图片预览 -->
    <imgView ref="imgView" :src.sync="viewSrc" />
    <a-modal v-model="pdfVisible" title="PDF 预览" width="80%" :footer="null">
      <div ref="pdfContainer" style="height: 70vh; overflow: auto;"></div>
    </a-modal>
  </div>
</template>

<script>
import { filePageQueryAPI } from "@/api/file.js";
export default {
  name: "gold-detail-other-file",
  data() {
    return {
      pageData: [],
      showMore: false,
       fileReadonly: false,
      pdfVisible: false,
      viewSrc: '', //图片预览地址
    };
  },
  created() {
    this.getTableList();
  },
  methods: {
    getTableList() {
      if(this.$route.params.gldId){
        filePageQueryAPI({
          tblBlId: this.$route.params.gldId

        })
          .then(res => {
            console.log(JSON.stringify(res))
            this.pageData = res.data.grid.list || [];
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    downloadFile(item) {
      const DOWNLOAD_PREFIX = "/gb-bigtree-file/download/fileDownload/install";
      window.open(
        `${DOWNLOAD_PREFIX}${item.fileRte}/${item.fileNm || item.name}`,
        "_blank"
      );
    },
    async lookFile(row) {
      console.log("%c Line:92 🍕 row", "color:#2eafb0", row);
      if(row&&row.fileExpdNm.indexOf('pdf')>-1){
        const pdfjsLib = await import('pdfjs-dist/build/pdf');
      const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry');

      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      console.log('%c Line:425 🍷 this.pdfUrl', 'color:#e41a6a', process.env);
      const pdfUrl = '/gb-bigtree-file/download/fileDownload/install' + row.fileRte + '/' + row.name;
      this.pdfVisible = true;

      // 加载 PDF
      const loadingTask = pdfjsLib.getDocument(pdfUrl);
      const pdf = await loadingTask.promise;

      // 渲染第一页
      const page = await pdf.getPage(1);
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      this.$refs.pdfContainer.innerHTML = '';
      this.$refs.pdfContainer.appendChild(canvas);

      await page.render({
        canvasContext: context,
        viewport
      }).promise;
      }else{
         this.viewSrc = '/gb-bigtree-file/download/fileDownload/install' + row.fileRte + '/' + row.fileNm;
         this.$refs.imgView.show();
      }
      console.log("%c Line:455 🍩 row", "color:#e41a6a", row);
      // this.pdfUrl = '/gb-bigtree-file/download/fileDownload/install' +
      //     row.file.fileRte +
      //     '/' +
      //     row.file.name
      //       this.pdfVisible = true;
      
    }
  },
  watch: {
    gldId(newVal) {
      this.getTableList();
    }
  },
  activated() {}
};
</script>
<style scoped>
.right-oper {
  float: right;
  margin: 0 10px 10px 0;
}
.table-common {
  width: 100%;
}
.table-common th {
  background: #f5f9fb;
  color: #1b1d1f;
}
.table-common th,
.table-common td {
  padding: 10px 10px;
  text-align: center;
  color: #1b1d1f;
}
.table-common td {
  font-size: 12px;
  background: #ffffff;
  border-bottom: 5px solid #f5f9fb;
}
.table-common tbody tr:nth-child(2n) {
  background: #f5f7f9;
}
</style>



// WEBPACK FOOTER //
// src/components/gold-page/gold-detail-other-file.vue